 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import THEBIRTHHOUSE_COVER from '@/components/thebirthhouse_cover'
 import LOVE_1 from '@/components/love_1'
 import THEBIRTHHOUSE from '@/components/thebirthhouse'
 import DED01 from '@/components/ded01'
 import CONTENTS from '@/components/contents'
 import PRO01 from '@/components/pro01'
 import PT01 from '@/components/pt01'
 import C01 from '@/components/c01'
 import CH01 from '@/components/ch01'
 import CH02 from '@/components/ch02'
 import CH03 from '@/components/ch03'
 import CH04 from '@/components/ch04'
 import CH05 from '@/components/ch05'
 import CH06 from '@/components/ch06'
 import CH07 from '@/components/ch07'
 import CH08 from '@/components/ch08'
 import CH09 from '@/components/ch09'
 import CH10 from '@/components/ch10'
 import CH11 from '@/components/ch11'
 import CH12 from '@/components/ch12'
 import CH13 from '@/components/ch13'
 import CH14 from '@/components/ch14'
 import CH15 from '@/components/ch15'
 import CH16 from '@/components/ch16'
 import CH17 from '@/components/ch17'
 import CH18 from '@/components/ch18'
 import CH19 from '@/components/ch19'
 import PT02 from '@/components/pt02'
 import CH20 from '@/components/ch20'
 import CH21 from '@/components/ch21'
 import CH22 from '@/components/ch22'
 import CH23 from '@/components/ch23'
 import CH24 from '@/components/ch24'
 import CH25 from '@/components/ch25'
 import CH26 from '@/components/ch26'
 import CH27 from '@/components/ch27'
 import CH28 from '@/components/ch28'
 import CH29 from '@/components/ch29'
 import CH30 from '@/components/ch30'
 import CH31 from '@/components/ch31'
 import CH32 from '@/components/ch32'
 import CH33 from '@/components/ch33'
 import CH34 from '@/components/ch34'
 import CH35 from '@/components/ch35'
 import CH36 from '@/components/ch36'
 import CH37 from '@/components/ch37'
 import PT03 from '@/components/pt03'
 import CH38 from '@/components/ch38'
 import CH39 from '@/components/ch39'
 import CH40 from '@/components/ch40'
 import CH41 from '@/components/ch41'
 import CH42 from '@/components/ch42'
 import CH43 from '@/components/ch43'
 import CH44 from '@/components/ch44'
 import CH45 from '@/components/ch45'
 import CH46 from '@/components/ch46'
 import CH47 from '@/components/ch47'
 import EPI01 from '@/components/epi01'
 import LOVE_2 from '@/components/love_2'
 import EXCERPT_HEAD from '@/components/Excerpt_head'
 import EXCERPT_1 from '@/components/Excerpt_1'
 import EXCERPT_TITLE from '@/components/Excerpt_Title'
 import EXCERPT_TITLE_1 from '@/components/Excerpt_Title_1'
 import EXCERPT_2_1 from '@/components/Excerpt_2_1'
 import EXCERPT_2_2 from '@/components/Excerpt_2_2'
 import EXCERPT_2_3 from '@/components/Excerpt_2_3'
 import NOT01 from '@/components/not01'
 import ATN01 from '@/components/atn01'
 import ACK01 from '@/components/ack01'
 import ATA01 from '@/components/ata01'
 import CRE01 from '@/components/cre01'
 import A780061859649_MCKAY_ADCARD from '@/components/9780061859649_McKay_adcard'
 import COP01 from '@/components/cop01'
 import ATP01 from '@/components/atp01'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/contents",
 			"name" : "contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/pro01",
 			"name" : "pro01",
 			"component" : PRO01
 		},
 		{
 			"path" : "/pt01",
 			"name" : "pt01",
 			"component" : PT01
 		},
 		{
 			"path" : "/c01",
 			"name" : "c01",
 			"component" : C01
 		},
 		{
 			"path" : "/ch01",
 			"name" : "ch01",
 			"component" : CH01
 		},
 		{
 			"path" : "/ch02",
 			"name" : "ch02",
 			"component" : CH02
 		},
 		{
 			"path" : "/ch03",
 			"name" : "ch03",
 			"component" : CH03
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js